/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseShapeIcon16Solid = forwardRef('MediaUiAPauseShapeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.25 2C3.56 2 3 2.56 3 3.25v9.5c0 .69.56 1.25 1.25 1.25h1.5C6.44 14 7 13.44 7 12.75v-9.5C7 2.56 6.44 2 5.75 2h-1.5Z" }),
        React.createElement("path", { d: "M10.25 2C9.56 2 9 2.56 9 3.25v9.5c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25v-9.5C13 2.56 12.44 2 11.75 2h-1.5Z" })));
});
